var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9429 4.50601H16.2314M6.56791 0.640625H14.2987C17.1451 0.640625 19.4525 2.94808 19.4525 5.79447V13.5252C19.4525 16.3716 17.1451 18.6791 14.2987 18.6791H6.56791C3.72152 18.6791 1.41406 16.3716 1.41406 13.5252V5.79447C1.41406 2.94808 3.72152 0.640625 6.56791 0.640625ZM10.4333 13.5252C8.2985 13.5252 6.56791 11.7946 6.56791 9.65986C6.56791 7.52506 8.2985 5.79447 10.4333 5.79447C12.5681 5.79447 14.2987 7.52506 14.2987 9.65986C14.2987 11.7946 12.5681 13.5252 10.4333 13.5252Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.28846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.fcc80db1a73fb82319cb34ada44a8d57.svg";
export { ForwardRef as ReactComponent };